import { Controller } from '@hotwired/stimulus'

export default class extends Controller {


  handleMenuItemClick(event) {
    const selectedItem = event.currentTarget;

    this.updateSubmenuSelection(selectedItem)
  }

  updateSubmenuSelection(selectedItem) {
    // Do what you want with the selected item
    // if you want to add a selected state, send this event
    this.contextMenu.dispatchEvent(new CustomEvent("markSelected", {
      detail: {
        item: selectedItem
      }
    }));

    // But you can also navigate to a new page, make an API call, etc here
  }

  get contextMenu(){
    return this.element.querySelector(".lui-context-menu");
  }
}
